"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationRequestDto = instanceOfOrientationRequestDto;
exports.OrientationRequestDtoFromJSON = OrientationRequestDtoFromJSON;
exports.OrientationRequestDtoFromJSONTyped = OrientationRequestDtoFromJSONTyped;
exports.OrientationRequestDtoToJSON = OrientationRequestDtoToJSON;
exports.OrientationRequestDtoToJSONTyped = OrientationRequestDtoToJSONTyped;
const NurseProfileDto_1 = require("./NurseProfileDto");
const ShiftRequestStatus_1 = require("./ShiftRequestStatus");
const RequestedBy_1 = require("./RequestedBy");
/**
 * Check if a given object implements the OrientationRequestDto interface.
 */
function instanceOfOrientationRequestDto(value) {
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    if (!('requestedBy' in value) || value['requestedBy'] === undefined)
        return false;
    if (!('requestStatus' in value) || value['requestStatus'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function OrientationRequestDtoFromJSON(json) {
    return OrientationRequestDtoFromJSONTyped(json, false);
}
function OrientationRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfile': (0, NurseProfileDto_1.NurseProfileDtoFromJSON)(json['nurseProfile']),
        'requestedBy': (0, RequestedBy_1.RequestedByFromJSON)(json['requestedBy']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusFromJSON)(json['requestStatus']),
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'requestedByProfile': json['requestedByProfile'] == null ? undefined : json['requestedByProfile'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function OrientationRequestDtoToJSON(json) {
    return OrientationRequestDtoToJSONTyped(json, false);
}
function OrientationRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfile': (0, NurseProfileDto_1.NurseProfileDtoToJSON)(value['nurseProfile']),
        'requestedBy': (0, RequestedBy_1.RequestedByToJSON)(value['requestedBy']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusToJSON)(value['requestStatus']),
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'requestedByProfile': value['requestedByProfile'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}
//# sourceMappingURL=OrientationRequestDto.js.map